// extracted by mini-css-extract-plugin
export default {"root":"PageUsers_root__mt2xM","top":"PageUsers_top__BFvF8"};